import type { StepType } from "@reactour/tour";
import basics from "./basics";
import charts from "./charts";
import formatting from "./formatting";
import fx from "./fx";
import goodbye from "./goodbye";
import grid from "./grid";
import images from "./images";
import intro from "./intro";
import links from "./links";
import publishing from "./publishing";
import split from "./split";
import stories from "./stories";

export const originalTourSteps = (hostId: string) => {
	const steps: StepType[] = [
		...intro,
		...basics(hostId),
		...stories(hostId),
		...formatting,
		...links,
		...images,
		...charts,
		...publishing,
		...split,
		...grid,
		...fx,
		...goodbye,
	];
	return steps;
};
